import strings from 'localization/strings';

const contactTypes = {
    mainEmail: {},
    mainMobileTelephone: {},
    checkInEmail: {},
    checkInMobileTelephone: {},
    paymentDocumentEmail: {},
    invoiceEmail: {},
    monthlyTransactionReportEmail: {},
    roundReportEmail: {},
    caretakerEmail: {},
    caretakerMobileTelephone: {},
    caretakerName: {}
};

Object.keys(contactTypes).forEach(key => {
    contactTypes[key].key = key;
});

strings.addLoadCallback(() => {
    Object.values(contactTypes).forEach(o => {
        o.title = strings.contactTypes[o.key];
    });
});

export default contactTypes;
